<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <div
    class="min-h-screen bg-[var(--color-bg)] text-[var(--color-text)] flex flex-col">
    <div
      class="flex-1 flex flex-col gap-5 sm:gap-6 container-padding pb-24 py-4">
      <!-- Setting Components -->
      <LegalNotice />
      <Licenses />
      <ToggleTheme />
      <ToggleInfo />
      <MoreLanguage />
      <FocalLengthSetting />
      <EartagPrefixSetting />
      <QuickLinksSetting />
      <BackupSetting />
      <AppInfo />
      <!-- DEV ONLY: Database Management Buttons -->
      <DevSeedButton />
      <DevTestSeedButton />
      <DevResetButton />
    </div>
  </div>
</template>

<script setup>
  import { onMounted } from 'vue' 
  import { useI18n } from 'vue-i18n'
  import { useUiStore } from '@/stores/ui.store.js' 

  import ToggleTheme from '@/components/settings/ToggleTheme.vue'
  import ToggleInfo from '@/components/settings/ToggleInfo.vue'
  import MoreLanguage from '@/components/settings/MoreLanguage.vue'
  import FocalLengthSetting from '@/components/settings/FocalLengthSetting.vue'
  import QuickLinksSetting from '@/components/settings/QuickLinksSetting.vue'
  import EartagPrefixSetting from '@/components/settings/EartagPrefixSetting.vue'
  import BackupSetting from '@/components/settings/BackupSetting.vue'
  import LegalNotice from '@/components/settings/LegalNotice.vue'
  import Licenses from '@/components/settings/Licenses.vue'
  import DevSeedButton from '@/components/dev/DevSeedButton.vue'
  import DevTestSeedButton from '@/components/dev/DevTestSeedButton.vue'
  import DevResetButton from '@/components/dev/DevResetButton.vue'
  import AppInfo from '@/components/settings/AppInfo.vue'

  const { t } = useI18n()
  const uiStore = useUiStore()

  onMounted(() => {
    uiStore.setHeader({
      title: t('views.more.title'), 
      showBack: false, 
      showAdd: false
    })
  })
</script>
